module.exports = __webpack_public_path__ + "img/develop.596edfac.png";